import { frontendURL } from 'dashboard/helper/URLHelper.js';

const VoiceCallDetailPage = () => import('./pages/VoiceCallDetailPage.vue');
const VoiceCallsListPage = () => import('./pages/VoiceCallsListPage.vue');
const VoiceCampaignsListPage = () =>
  import('./pages/VoiceCampaignsListPage.vue');
const VoiceCampaignDetailPage = () =>
  import('./pages/VoiceCampaignDetailPage.vue');
const VoiceCampaignWizardPage = () =>
  import('./pages/VoiceCampaignWizardPage.vue');
const VoiceCostDashboardPage = () =>
  import('./pages/VoiceCostDashboardPage.vue');
const VoiceSearchPage = () => import('./pages/VoiceSearchPage.vue');
const VoiceOverviewPage = () => import('./pages/VoiceOverviewPage.vue');
const VoicePlaygroundPage = () => import('./pages/VoicePlaygroundPage.vue');

// Voice routes — see docs/design/ai_voice_platform.md §10.2 + §10.3 + §10.4.
const voiceRoutes = {
  routes: [
    {
      // /voice (no suffix) redirects to the overview landing page so
      // typing the URL bare, clicking a stale bookmark, or following a
      // pre-Sprint-4 link all land on the manager dashboard rather than
      // a 404 or a random child route. Implemented as a router-level
      // redirect (not a server redirect) so the SPA doesn't refetch
      // assets.
      path: frontendURL('accounts/:accountId/voice'),
      redirect: to => ({
        name: 'voice_overview',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      // Sprint 4 polish — manager landing page (Voice Overview).
      path: frontendURL('accounts/:accountId/voice/overview'),
      name: 'voice_overview',
      meta: {
        permissions: ['administrator'],
      },
      component: VoiceOverviewPage,
    },
    {
      path: frontendURL('accounts/:accountId/voice/calls'),
      name: 'voice_calls_list',
      meta: {
        permissions: ['administrator'],
      },
      component: VoiceCallsListPage,
    },
    {
      path: frontendURL('accounts/:accountId/voice/calls/:id'),
      name: 'voice_call_detail',
      meta: {
        permissions: ['administrator'],
      },
      component: VoiceCallDetailPage,
    },
    {
      path: frontendURL('accounts/:accountId/voice/campaigns'),
      name: 'voice_campaigns_list',
      meta: {
        permissions: ['administrator'],
      },
      component: VoiceCampaignsListPage,
    },
    {
      // /new must be registered BEFORE /:id — otherwise Vue Router
      // greedily binds 'new' as the :id param and renders the detail
      // page on a 404 path.
      path: frontendURL('accounts/:accountId/voice/campaigns/new'),
      name: 'voice_campaign_new',
      meta: {
        permissions: ['administrator'],
      },
      component: VoiceCampaignWizardPage,
    },
    {
      path: frontendURL('accounts/:accountId/voice/campaigns/:id'),
      name: 'voice_campaign_detail',
      meta: {
        permissions: ['administrator'],
      },
      component: VoiceCampaignDetailPage,
    },
    {
      path: frontendURL('accounts/:accountId/voice/costs'),
      name: 'voice_costs_dashboard',
      meta: {
        permissions: ['administrator'],
      },
      component: VoiceCostDashboardPage,
    },
    {
      // Sprint 4 — semantic search across past voice calls (UC-2).
      path: frontendURL('accounts/:accountId/voice/search'),
      name: 'voice_search',
      meta: {
        permissions: ['administrator'],
      },
      component: VoiceSearchPage,
    },
    {
      // Sprint 4 polish — playground for testing the AI receptionist
      // without burning Twilio credit.
      path: frontendURL('accounts/:accountId/voice/playground'),
      name: 'voice_playground',
      meta: {
        permissions: ['administrator'],
      },
      component: VoicePlaygroundPage,
    },
  ],
};

export default voiceRoutes;
